import { atom } from "recoil";

export type ThemeType = "dark" | "light";

export const ThemeState = atom<ThemeType>({
  key: "themeState",
  default: "light",
});
